// extracted by mini-css-extract-plugin
export default {"indicator":"CarouselIndicator_indicator__uA384","active":"CarouselIndicator_active__deh08","inactive":"CarouselIndicator_inactive__u4ZPM"};